import { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '../store';
import { LoadOptions } from 'devextreme/data/load_options';

export abstract class CrudServiceBase<DtoType> {
  client: QuestelServicesClient;

  constructor(baseUrl: string) {
    if(baseUrl.endsWith("/")) {
      baseUrl = baseUrl.slice(0, -1);
    }
    this.client = new QuestelServicesClient(store, `${baseUrl}`);
  }

  async create(data: DtoType) : Promise<RequestResult> {
    return await this.client.postJson('', data);
  }

  async get(id: Guid): Promise<DtoType> {
    return await this.client.get<DtoType>(`/${id}`);
  }

  async search(options: LoadOptions) : Promise<any> {
    return await this.client.getPostData(`/search`, options);
  }

  async edit(id: Guid, data: DtoType) : Promise<RequestResult> {
    return await this.client.sendRequest(HttpMethodEnum.Put, `/${id}`, data);
  }

  async delete(id: Guid) : Promise<RequestResult> {
    return await this.client.sendRequest(HttpMethodEnum.Delete, `/${id}`);
  }
}